import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59d3e0ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "join-perks" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" Join A Company "),
    /*#__PURE__*/_createElementVNode("span", { class: "color" }, " Where ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SliderTop = _resolveComponent("SliderTop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_SliderTop, { class: "perks-list" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.perks, (couple, coupleIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "perk-couple animate",
              key: `couple-${coupleIndex}`
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(couple, (perk, perkIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "perk",
                  key: `perk-${coupleIndex}-${perkIndex}`
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["icon", `nr-${coupleIndex * 2 + perkIndex + 1}`])
                  }, null, 2),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(perk), 1)
                ]))
              }), 128))
            ]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}